export const dataSourceConfig = {
    text: 'display',
    value: 'code',
};

export const dsConfigServiceAddr = {
    text: 'desc',
    value: 'code',
};

export const dataSourceConfigParams=(text,value)=>{
    let params={}
    params.text=text;
    params.value=value

    return params;
}
exports.dataSourceConfig=dataSourceConfig;
exports.dsConfigServiceAddr=dsConfigServiceAddr;
exports.dataSourceConfigParams=dataSourceConfigParams;


// WEBPACK FOOTER //
// ./src/views/ProjectApollo/common.js